import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IFBFile } from 'interfaces';

@Injectable({
  providedIn: 'root'
})
export class FileUploaderFiltersService {
  private readonly ALLOWED_RESUME_EXTENSIONS = ['.pdf', '.docx', '.doc', '.zip'];
  private readonly ALLOWED_IMAGE_EXTENSIONS = ['.jpg', '.png', '.jpeg', '.bmp'];

  imageFilter(file: IFBFile): boolean {
    const ext = file.name ? file.name.substr(file.name.lastIndexOf('.')).toLowerCase() : '';
    return this.ALLOWED_IMAGE_EXTENSIONS.indexOf(ext) !== -1;
  }

  imageMinSizeFilter(file: IFBFile, minWidth: number, minHeight: number) {
    const result$ = new Subject<boolean>();
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      if (img.width >= minWidth && img.height >= minHeight) {
        result$.next(true);
      } else {
        result$.next(false);
      }
    };
    img.src = URL.createObjectURL(file);
    return result$.asObservable();
  }

  imageMaxSizeFilter(file: IFBFile, maxWidth: number, maxHeight: number) {
    const result$ = new Subject<boolean>();
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      if (img.width <= maxWidth && img.height <= maxHeight) {
        result$.next(true);
      } else {
        result$.next(false);
      }
    };
    img.src = URL.createObjectURL(file);
    return result$.asObservable();
  }

  pdfFilter(file: IFBFile): boolean {
    const ext = file.name ? file.name.substr(file.name.lastIndexOf('.')).toLowerCase() : '';
    return ext === '.pdf';
  }

  resumeFilter(file: IFBFile): boolean {
    const ext = file.name ? file.name.substr(file.name.lastIndexOf('.')).toLowerCase() : '';
    return this.ALLOWED_RESUME_EXTENSIONS.indexOf(ext) !== -1;
  }

  sizeFilter(file: IFBFile): boolean {
    return file.size <= 8 * 1024 * 1024;
  }
}
